import { Injectable } from '@angular/core';
import {HttpClientService} from './http-client.service';
import {AppConfigService} from './app-config.service';

@Injectable()
export class ViewOrdersService {

  private apiUrl = AppConfigService.settings.apiUrl + 'orders/';

  constructor(private http: HttpClientService) {
  }

  getData(): Promise<any[]> {
    return this.http.get(this.apiUrl + 'view')
      .toPromise()
      .then(response => response.json() as any[])
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/view-orders.service.ts